<template>
  <OptionSelectBase :is-multi-select="true" v-model:fields="fields" @on-click="emit('onClick')" />
</template>

<script setup lang="ts">
import OptionSelectBase from '../OptionSelectBase/OptionSelectBase.vue'
import { type OptionSelectFields, getDefaultOptionSelectFields } from '../OptionSelectBase/types'
import { usePipe } from '@render/composables/usePipe'
import { useFormInput } from '@render/composables/useFormInput'

type Fields = OptionSelectFields & {
  required?: boolean
  disableRealtimeValidation?: boolean
}

const fields = defineModel<Fields>('fields', {
  required: true,
  default: () => getDefaultOptionSelectFields({ showIndicator: true }),
})

const emit = defineEmits<{
  (e: 'onClick'): void
}>()

const pipe = usePipe()

useFormInput({
  validate: () => {
    if (!fields.value.required) return true
    const raw = pipe.getData(`var.${fields.value.valueVariable?.key ?? ''}`)
    return Array.isArray(raw) && raw.length > 0
  },
  disableRealtimeValidation: () => fields.value.disableRealtimeValidation === true,
})
</script>
